/**
 * MY — Transfer of Shares (M32201) Register Detail 매핑.
 *
 * ⚠️ TASK_DATA.formData 실제 구조 (PreSetTransferSharesPanel.gatherState):
 *   {
 *     companyName, companyRegistrationNo, companyRegistrationNoOld,
 *     governingDocumentType, constitutionClauseNo, directorCount, memberCount, hasCommonSeal,
 *     transfers: [{ transferorName, transferorContactCd, certificateNo, shares, shareType,
 *                   transfereeName, transfereeContactCd, newCertificateNo, newShares, section105 }],
 *     executionDate, resolutionDate, transferDate, letterDate, ...
 *   }
 *   → repeat 는 transfers 기준(양도 1건 = 행 1개). 실제 등록은 TaskListPage 의
 *     registerTransfersForTransferTask 가 entity_my/shares(event_type='Transfer' + transfer_details)로 수행.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

const TRANSFER_REGISTER_DETAIL = {
  title: 'Transfer of Shares Details',
  repeatArrayPath: 'transfers',
  fields: [
    // 회사 (비반복 — 모든 행 동일)
    { label: 'Company Name', key: ['companyName', 'entityName', 'company_name'] },
    { label: 'Registration No.', key: ['companyRegistrationNo', 'entityRegNo'] },
    // 양도 내역 행별
    { label: 'Transferor', key: ['transfers.0.transferorName'] },
    { label: 'Transferee', key: ['transfers.0.transfereeName'] },
    { label: 'Class', key: ['transfers.0.shareType'] },
    { label: 'Shares', key: ['transfers.0.shares'] },
    { label: 'From Cert', key: ['transfers.0.certificateNo'] },
    { label: 'To Cert', key: ['transfers.0.newCertificateNo'] },
  ],
} as const;

// with SC(M32201) / without SC(M32204) — 동일 formData 구조라 매핑 공유.
registerRegisterDetail('M32201', TRANSFER_REGISTER_DETAIL as any);
registerRegisterDetail('M32204', TRANSFER_REGISTER_DETAIL as any);
